import React, { useEffect } from "react";
import styles from "./Modal.module.scss";
import useModal from "./useModal";
import ModalHandler from "./ModalHandler";

export default function Modal({ isOpen, onClose, title, children }) {
  const { stateModal, setModal } = useModal({ isOpen });
  const handlers = ModalHandler(stateModal, setModal, onClose);

  // Sync external isOpen prop with internal state
  useEffect(() => {
    setModal("isOpen", isOpen);
  }, [isOpen, setModal]);

  // Handle ESC key press
  useEffect(() => {
    const handleEsc = handlers.handleEscKey;
    if (stateModal.isOpen) {
      document.addEventListener("keydown", handleEsc);
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEsc);
      document.body.style.overflow = "unset";
    };
  }, [stateModal.isOpen, handlers.handleEscKey]);

  if (!stateModal.isOpen) return null;

  return (
    <div className={styles.Overlay} onClick={handlers.handleBackdropClick}>
      <div className={styles.Modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.Header}>
          <h3 className={styles.Title}>{title}</h3>
          <button
            className={styles.CloseButton}
            onClick={handlers.handleClose}
            aria-label="Close modal"
          >
            <span className="material-icons">close</span>
          </button>
        </div>
        <div className={styles.Content}>{children}</div>
      </div>
    </div>
  );
}
